const Color = {
    DisabledText: "#a6a6a6",
    EnabledText: "#000000",
}

export { Color };